<template>
  <div>
    <template v-for="(t, index) in splitText" :key="index">
      <a v-if="t.isLink" :href="t.text" target="_blank">{{ t.text }}</a>
      <span
        v-else
        :class="{ 'opacity-80': !darker, 'opacity-100': fullOpacity }"
        >{{ t.text }}</span
      >
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true
  },
  darker: Boolean,
  fullOpacity: Boolean
});

const urlRegex = new RegExp(/(https:\/\/[^\s"]+)/gi);

const splitText = [];

props.text.split(urlRegex).forEach(text => {
  let t = text;
  const isLink = urlRegex.test(t);

  let pushed = false;
  if (isLink) {
    if (t.startsWith("(")) {
      splitText.push({ isLink: false, text: "(" });
      t = t.substring(1);
    }

    [")", "."].forEach(c => {
      if (t.endsWith(c)) {
        t = t.substring(0, t.length - 1);
        pushed = true;
        splitText.push({ isLink, text: t });
        splitText.push({ isLink: false, text: c });
      }
    });
  }

  if (!pushed) splitText.push({ isLink, text: t });
});
</script>
